import styled from 'styled-components'
import { withOpacity } from '../../helpers'

export default styled.div`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px;
  text-align: center;
  background-color: ${ ({ theme }) => withOpacity(theme.colors.white, 90) };
  color: ${ ({ theme }) => theme.colors.black };
`
